(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["frete-stefanes"] && !Shopify.designMode) return;
  try {
    
  // Faixas oficiais de CEP por estado, sobre os 5 primeiros dígitos.
  // Cobrem 01000 a 99999 sem buraco, então todo CEP válido resolve para uma UF.
  const FAIXAS_CEP = [
    [1000, 19999, 'SP'], [20000, 28999, 'RJ'], [29000, 29999, 'ES'],
    [30000, 39999, 'MG'], [40000, 48999, 'BA'], [49000, 49999, 'SE'],
    [50000, 56999, 'PE'], [57000, 57999, 'AL'], [58000, 58999, 'PB'],
    [59000, 59999, 'RN'], [60000, 63999, 'CE'], [64000, 64999, 'PI'],
    [65000, 65999, 'MA'], [66000, 68899, 'PA'], [68900, 68999, 'AP'],
    [69000, 69299, 'AM'], [69300, 69399, 'RR'], [69400, 69899, 'AM'],
    [69900, 69999, 'AC'], [70000, 72799, 'DF'], [72800, 72999, 'GO'],
    [73000, 73699, 'DF'], [73700, 76799, 'GO'], [76800, 76999, 'RO'],
    [77000, 77999, 'TO'], [78000, 78899, 'MT'], [78900, 78999, 'RO'],
    [79000, 79999, 'MS'], [80000, 87999, 'PR'], [88000, 89999, 'SC'],
    [90000, 99999, 'RS'],
  ];

  const ufPorCep = (cep) => {
    const prefixo = parseInt(cep.slice(0, 5), 10);
    const faixa = FAIXAS_CEP.find(([min, max]) => prefixo >= min && prefixo <= max);
    return faixa ? faixa[2] : null;
  };

  const formatarCep = (valor) => {
    const d = valor.replace(/\D/g, '').slice(0, 8);
    return d.length > 5 ? `${d.slice(0, 5)}-${d.slice(5)}` : d;
  };

  const dinheiro = (valor) =>
    Number(valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

  class CalculadoraFrete extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('[data-form]');
      this.campo = this.querySelector('[data-cep]');
      this.botao = this.querySelector('[data-enviar]');
      this.rotulo = this.querySelector('[data-rotulo]');
      this.saida = this.querySelector('[data-resultado]');

      this.campo.addEventListener('input', () => {
        this.campo.value = formatarCep(this.campo.value);
      });

      this.form.addEventListener('submit', (evento) => {
        evento.preventDefault();
        this.calcular();
      });

      // Reaproveita o último CEP consultado neste navegador.
      try {
        const salvo = localStorage.getItem('stefanes:cep');
        if (salvo) this.campo.value = formatarCep(salvo);
      } catch (e) {
        /* navegação privada ou storage bloqueado: apenas ignora */
      }
    }

    erro(mensagem) {
      this.saida.innerHTML = `<p class="frete-stefanes__erro">${mensagem}</p>`;
    }

    async calcular() {
      const cep = this.campo.value.replace(/\D/g, '');

      if (cep.length !== 8) {
        this.erro('Digite um CEP com 8 dígitos.');
        return;
      }

      const uf = ufPorCep(cep);
      if (!uf) {
        this.erro('CEP não reconhecido. Confira os números.');
        return;
      }

      try {
        localStorage.setItem('stefanes:cep', cep);
      } catch (e) {
        /* sem storage: segue sem lembrar */
      }

      this.carregando(true);
      let variantePendente = null;

      try {
        // /cart/shipping_rates.json cota o carrinho atual. Na página de produto
        // ele pode estar vazio, então adicionamos o item, consultamos e removemos,
        // devolvendo o carrinho ao estado anterior.
        const carrinho = await fetch('/cart.js').then((r) => r.json());
        const variantId = this.dataset.variantId;

        if (carrinho.item_count === 0) {
          if (!variantId) {
            this.erro('Adicione um produto disponível ao carrinho para calcular o frete.');
            return;
          }
          const adicao = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: Number(variantId), quantity: 1 }),
          });
          if (!adicao.ok) {
            this.erro('Não foi possível calcular agora. Tente novamente.');
            return;
          }
          variantePendente = Number(variantId);
        }

        const busca = new URLSearchParams({
          'shipping_address[zip]': cep,
          'shipping_address[country]': 'Brazil',
          'shipping_address[province]': uf,
        });
        const resposta = await fetch(`/cart/shipping_rates.json?${busca}`);
        const dados = await resposta.json();
        this.mostrar(dados.shipping_rates || [], cep, uf);
      } catch (e) {
        this.erro('Não foi possível calcular agora. Tente novamente.');
      } finally {
        if (variantePendente) {
          // Desfaz a adição temporária sem tocar em outras linhas.
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantePendente, quantity: 0 }),
          }).catch(() => {});
        }
        this.carregando(false);
      }
    }

    carregando(ativo) {
      this.botao.disabled = ativo;
      this.rotulo.textContent = ativo ? 'Calculando…' : 'Calcular';
    }

    mostrar(tarifas, cep, uf) {
      if (!tarifas.length) {
        this.erro('Não encontramos envio para este CEP. Fale com a gente.');
        return;
      }

      const cabecalho = `<p>Frete para ${formatarCep(cep)} · ${uf}</p>`;
      const linhas = tarifas
        .map((tarifa) => {
          const dias = tarifa.delivery_days || [];
          let prazo = '';
          if (dias.length === 2 && dias[0] !== dias[1]) {
            prazo = `<span class="frete-stefanes__prazo">${dias[0]} a ${dias[1]} dias úteis</span>`;
          } else if (dias.length) {
            prazo = `<span class="frete-stefanes__prazo">${dias[0]} dias úteis</span>`;
          }
          return `<div class="frete-stefanes__tarifa">
              <span>${tarifa.presentment_name || tarifa.name}${prazo}</span>
              <span class="frete-stefanes__preco">${dinheiro(tarifa.price)}</span>
            </div>`;
        })
        .join('');

      this.saida.innerHTML = cabecalho + linhas;
    }
  }

  if (!customElements.get('calculadora-frete')) {
    customElements.define('calculadora-frete', CalculadoraFrete);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
